/* Professional-page interactions. No storage APIs. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initializeFaq(root) {
    root.querySelectorAll('[data-ka-pro-faq]').forEach(function (faq) {
      if (faq.dataset.kaProReady === 'true') return;
      faq.dataset.kaProReady = 'true';

      faq.addEventListener('click', function (event) {
        var button = event.target.closest('.faq-q');
        if (!button || !faq.contains(button)) return;
        var answer = document.getElementById(button.getAttribute('aria-controls'));
        if (!answer) return;
        var expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        answer.hidden = expanded;
      });
    });
  }

  function initializeCarousels(root) {
    root.querySelectorAll('[data-ka-pro-carousel]').forEach(function (carousel) {
      if (carousel.dataset.kaProReady === 'true') return;
      var track = carousel.querySelector('[data-ka-pro-carousel-track]');
      var previous = carousel.querySelector('[data-ka-pro-carousel-prev]');
      var next = carousel.querySelector('[data-ka-pro-carousel-next]');
      var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-ka-pro-carousel-dots] button'));
      var slides = track ? Array.prototype.slice.call(track.querySelectorAll('.car-slide')) : [];
      if (!track || slides.length === 0) return;
      carousel.dataset.kaProReady = 'true';

      function currentIndex() {
        var current = track.scrollLeft;
        var bestIndex = 0;
        var bestDistance = Infinity;
        slides.forEach(function (slide, index) {
          var distance = Math.abs(slide.offsetLeft - track.offsetLeft - current);
          if (distance < bestDistance) {
            bestDistance = distance;
            bestIndex = index;
          }
        });
        return bestIndex;
      }

      function goTo(index) {
        var targetIndex = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({
          left: slides[targetIndex].offsetLeft - track.offsetLeft,
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
      }

      function synchronize() {
        var index = currentIndex();
        dots.forEach(function (dot, dotIndex) {
          dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
        });
        if (previous) previous.disabled = index === 0;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }

      if (previous) previous.addEventListener('click', function () { goTo(currentIndex() - 1); });
      if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });
      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () { goTo(index); });
      });
      track.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(currentIndex() + 1);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(currentIndex() - 1);
        }
      });

      var synchronizeTimer;
      track.addEventListener('scroll', function () {
        window.clearTimeout(synchronizeTimer);
        synchronizeTimer = window.setTimeout(synchronize, 90);
      }, { passive: true });
      synchronize();
    });
  }

  function initializeContactForms(root) {
    root.querySelectorAll('[data-ka-pro-contact-form]').forEach(function (section) {
      if (section.dataset.kaProFormReady === 'true') return;
      var form = section.querySelector('.kaProNativeForm');
      if (!form) return;
      section.dataset.kaProFormReady = 'true';

      var groups = Array.prototype.slice.call(form.querySelectorAll('[data-required-checkbox-group]'));

      function validateGroup(group) {
        var inputs = Array.prototype.slice.call(group.querySelectorAll('input[type="checkbox"]'));
        var error = group.querySelector('[data-checkbox-group-error]');
        var valid = inputs.some(function (input) { return input.checked; });
        group.setAttribute('aria-invalid', valid ? 'false' : 'true');
        if (error) error.hidden = valid;
        return valid;
      }

      groups.forEach(function (group) {
        group.addEventListener('change', function () { validateGroup(group); });
      });

      form.addEventListener('submit', function (event) {
        var firstInvalidGroup = groups.find(function (group) { return !validateGroup(group); });
        if (firstInvalidGroup) {
          event.preventDefault();
          var firstCheckbox = firstInvalidGroup.querySelector('input[type="checkbox"]');
          if (firstCheckbox) firstCheckbox.focus();
          return;
        }

        var submit = form.querySelector('button[type="submit"]');
        if (submit) submit.disabled = true;
      });
    });
  }

  function openLinkedFaq() {
    if (!window.location.hash) return;
    var target = document.querySelector(window.location.hash);
    if (target && target.classList.contains('faq-q') && target.getAttribute('aria-expanded') !== 'true') {
      target.click();
    }
  }

  function initialize(root) {
    initializeFaq(root);
    initializeCarousels(root);
    initializeContactForms(root);
  }

  initialize(document);
  openLinkedFaq();
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
}());
